import { CustomEventConfig } from '~/common/types';

export class EventListenerManager {
  private listeners: Map<string, EventListener> = new Map();

  registerListener(
    eventConfig: CustomEventConfig,
    handler: EventListener,
  ): void {
    const { name } = eventConfig;

    // event listener already registered, skip
    if (this.listeners.has(name)) {
      return;
    }

    window.addEventListener(name, handler);
    this.listeners.set(name, handler);
  }

  removeListener(eventName: string): void {
    const handler = this.listeners.get(eventName);
    if (!handler) return;

    window.removeEventListener(eventName, handler);
    this.listeners.delete(eventName);
  }

  removeAllListeners(): void {
    this.listeners.forEach((handler, eventName) => {
      window.removeEventListener(eventName, handler);
    });
    this.listeners.clear();
  }
}

export const PLUGIN_SUPPORTED_EVENTS = {
  RELOAD_CUSTOMER: 'PLUGIN:CUSTOMER:RELOAD',
  NAVIGATE: 'PLUGIN:NAVIGATE',
  UPDATE_LOCALE: 'PLUGIN:LOCALE:UPDATE',
};

export const INTERNAL_SUPPORTED_EVENTS = {
  RELOAD_CUSTOMER: 'INTERNAL:CUSTOMER:RELOAD',
  NAVIGATE: 'INTERNAL:NAVIGATE',
  UPDATE_LOCALE: 'INTERNAL:LOCALE:UPDATE',
};
